export class InsuranceForD2CDto {
    constructor(initializer) {
        this.insuranceName = initializer.insuranceName;
        this.insuranceId = initializer.insuranceId;
        this.pricingVersion = initializer.pricingVersion;
        this.insuranceInfo = initializer.insuranceInfo;
        this.listPrice = initializer.listPrice;
        this.userFinalPrice = initializer.userFinalPrice;
        this.insurancePrice = initializer.insurancePrice;
        this.finalPrice = initializer.finalPrice;
        this.fullCoverageInsurancePrice = initializer.fullCoverageInsurancePrice;
    }
}
